import { Utilities } from "../../../utils/utilities";
import { ReadAccess } from "../General/AccessData";
import CollectionLoader from "../General/CollectionLoader";
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { CollectionItemDeviationData } from "../Property/Collections/CollectionItemDeviationData";
import { PropertyData } from "../Property/PropertyData";
import { CollectionData } from "./CollectionData";

export class CollectionItemData extends FirebaseData {
  name: string = "";
  collection: CollectionData | undefined = undefined;
  properties: PropertyData[] = [];

  fields: {
    [fieldID: string]: {
      value: any;
    };
  } = {};
  readAccess: ReadAccess = {};
  writeAccess: ReadAccess | undefined = undefined;
  propertyFileIDs: string[] = [];

  deviations: CollectionLoader<CollectionItemDeviationData>;

  constructor(id: string, collectionName: string, parent: FirebaseData | undefined) {
    super(id, collectionName, parent);
    this.deviations = new CollectionLoader("deviations", this, CollectionItemDeviationData);
  }

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";
    this.collection = typeof data.collectionID === "string" ? LocalData.collections.addData(data.collectionID) : undefined;
    this.properties = Array.isArray(data.propertyIDs) ? data.propertyIDs.map((id: string) => LocalData.properties.addData(id)) : [];

    this.fields = {};
    if (typeof data.fields === "object") {
      for (const key of Object.keys(data.fields)) {
        if (typeof data.fields[key] !== "object") continue;
        this.fields[key] = {
          value: data.fields[key].value,
        };
      }
    }
    this.readAccess = Utilities.getReadAccess(data.readAccess);
    this.writeAccess = Utilities.getOptionalReadAccess(data.writeAccess);

    this.propertyFileIDs = Array.isArray(data.propertyFileIDs) ? data.propertyFileIDs : [];

    super.setup(data);
  }

  hasWriteAccess() {
    return Utilities.hasAccess(this.writeAccess ?? this.readAccess, undefined);
  }
}

